<ng-container [formGroup] = 'dateRangeForm'>
  <div class="input-container input-container--less-bottom input-container--basis-md">
    <label class="input-container__label">
      {{requiredStart ? 'Start Date *' : 'Start Date'}}
      <dx-date-box id="date-range.start-date" type="date" class="input-container__field margin-bottom--none" formControlName="startDate" useMaskBehavior="true" showClearButton="true" (blur)="onTouched()">
      </dx-date-box>
      <app-control-messages id="date-range.start-required" class="input-container__error" [control]="dateRangeForm.get('startDate')" showBeforeTouch="true"></app-control-messages>
    </label>
  </div>
  <div class="input-container input-container--less-bottom input-container--basis-md">
    <label class="input-container__label">
      End Date
      <dx-date-box id="date-range.end-date" type="date" class="input-container__field margin-bottom--none" formControlName="endDate" useMaskBehavior="true" showClearButton="true" (blur)="onTouched()">
      </dx-date-box>
      <app-control-messages id="date-range.end-required" class="input-container__error" [control]="dateRangeForm.get('endDate')" showBeforeTouch="true"></app-control-messages>
    </label>
  </div>
</ng-container>
